import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import api from '@/lib/api';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(function () {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    var hash = window.location.hash;
    var match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/login');
      return;
    }
    var sessionId = match[1];

    async function processSession() {
      try {
        var resp = await api.post('/auth/google/session', { session_id: sessionId });
        var data = resp.data;

        if (data.needs_role) {
          navigate('/select-role', { state: { googleData: data, pending_token: data.pending_token } });
          return;
        }

        if (data.token) localStorage.setItem('dw_token', data.token);
        if (typeof setUser === 'function') setUser(data);

        var dest = data.role === 'admin' ? '/admin' : data.role === 'advertiser' ? '/advertiser' : '/affiliate';
        window.history.replaceState(null, '', dest);
        navigate(dest);
      } catch (err) {
        console.error('Google auth error:', err);
        navigate('/login');
      }
    }
    processSession();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center mx-auto mb-3 animate-pulse">
          <span className="text-white font-bold text-lg">DW</span>
        </div>
        <p className="text-zinc-400 text-sm">Completing sign in...</p>
      </div>
    </div>
  );
}
